__turbopack_context__.v({
  "buttonAlignCenter": "Oj1RTq_buttonAlignCenter",
  "buttonAlignLeft": "Oj1RTq_buttonAlignLeft",
  "buttonAlignRight": "Oj1RTq_buttonAlignRight",
  "price": "Oj1RTq_price",
  "productBox": "Oj1RTq_productBox",
  "productBoxContent": "Oj1RTq_productBoxContent",
  "productBoxHead": "Oj1RTq_productBoxHead",
  "textAlignCenter": "Oj1RTq_textAlignCenter",
  "textAlignLeft": "Oj1RTq_textAlignLeft",
  "textAlignRight": "Oj1RTq_textAlignRight",
});
